module.exports = __webpack_public_path__ + "img/epoch-upper-right.997ad41a.svg";